export { ModalWithPersistedState } from './element'

export interface IProps {
  isOpen: boolean
  onRequestClose: () => void
  children: React.ReactNode
  borderRadius?: string
  size?: string
  backgroundColor?: string
  overlayBackgroundColor?: string
  hasBlurredOverlay?: boolean
  showCloseIcon?: boolean
  className?: string
}
